export default __webpack_public_path__ + "static/media/chart5.d5ccee58.svg";